import op from './lib/op';
import is from './lib/is';

export {
  op,
  is,
};
